// #ux-redesign-start: EmptyState primitive (Paso 2)
// Reemplaza los "No data" inline y los textos huérfanos como "Chat auswählen"
// que aparecen sin CTA ni guía.
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <EmptyState
//     title="Keine ausstehenden Studien"
//     description="Alle Befunde wurden bereits zugewiesen."
//   />
//
//   <EmptyState
//     icon={<MicroscopeIcon />}
//     title="Noch keine Befunde"
//     description="Sobald HL7-Daten ankommen, erscheinen sie hier."
//     action={<Button variant="primary" onClick={...}>Manuell hochladen</Button>}
//   />
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const EmptyState = ({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className = '',
}) => {
  const classes = [
    'ds-empty',
    `ds-empty--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status">
      {icon && (
        <div className="ds-empty__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      {title && <p className="ds-empty__title">{title}</p>}
      {description && <p className="ds-empty__description">{description}</p>}
      {action && <div className="ds-empty__action">{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  action: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'compact']),
  className: PropTypes.string,
};

export default EmptyState;
// #ux-redesign-end
